import type { PageData } from '~/components/report/types'

import ReportGate from './ReportGate'

export default function PDFDownloadLayout(props: PageData) {
  const { pdfFile } = props
  if (!pdfFile) return null

  return (
    <>
      <ReportGate {...props} isLoggedIn={true} />
    </>
  )
}
